import Turnstile from 'react-turnstile';

import { RECAPTCHA_NEEDED } from '@/config';

export type CaptchaTurnstileProps = {
  siteKey: string;
  onVerify: (value: string | null) => void;
};

export const CaptchaTurnstile = ({ siteKey, onVerify }: CaptchaTurnstileProps) => {
  const onVerifyDefault = (value: string | null) => {
    onVerify && onVerify(value);
  };
  if (!RECAPTCHA_NEEDED) {
    onVerifyDefault('NOT');
    return <></>;
  }

  return <Turnstile sitekey={siteKey} onVerify={onVerifyDefault} />;
};
